import { createRecipe, implementCustomExpressions } from '../__generated/implementation.js';
import { HandrailEndType, HandrailPossibleWallEndType } from '../__generated/model/index.js';
import { getBalustrade } from '../projections/balustrade.js';
export const deckSectionExpressions = implementCustomExpressions({
    DeckSection: {
        $centerX: (s)=>{
            return s.length / 2;
        },
        $levelHeight: (s)=>{
            return s.$deck.$shapeHeights.levels[s.id];
        },
        $balustrades: (s, state, ctx)=>{
            if (!s.balustrade) {
                return [];
            }
            const line = ctx.sketchingProjections.getEntityLine(s.id, state, 'main');
            const leftConnection = line.start.connection;
            const leftConnectionEntity = leftConnection?.from.shape.instance.entityId ? ctx.domain.get$Entity(leftConnection.from.shape.instance.entityId, state) : undefined;
            const rightConnection = line.end.connection;
            const rightConnectionEntity = rightConnection?.to.shape.instance.entityId ? ctx.domain.get$Entity(rightConnection.to.shape.instance.entityId, state) : undefined;
            const key = `${s.id}_line_balustrade`;
            const edgeOffset = -100;
            const balustrade = getBalustrade(line, leftConnection, leftConnectionEntity, rightConnection, rightConnectionEntity, key, line.length, s.$deck.$maxBalustradeSectionLength, s.$deck.$maxPostDistance, s.$deck.useThinIntermediatePosts, 0, 0, false, edgeOffset, 0, s.$deck.handrailType, s.$deck.postType);
            return [
                balustrade
            ];
        },
        $posts: (s)=>{
            const posts = s.$balustrades.flatMap((b)=>b.sections).flatMap((section)=>section.posts.flatMap((post)=>{
                    if (post.shared) {
                        return [];
                    }
                    return createRecipe({
                        type: 'Post',
                        key: post.key,
                        deckItemId: s.id,
                        positionType: post.positionType,
                        x: post.x,
                        y: post.y,
                        z: section.edgeOffset,
                        slope: post.slope
                    });
                }));
            return posts;
        },
        $fixingSystems: (s)=>{
            const fixingSystems = s.$balustrades.flatMap((b)=>b.sections).flatMap((section, i)=>{
                const leftPost = section.posts[0];
                const rightPost = section.posts[section.posts.length - 1];
                return Array.from({
                    length: s.$deck.$numberOfWires
                }, (_, j)=>{
                    return createRecipe({
                        type: 'FixingSystem',
                        key: `${section.key}_fixing_system_${i}_${j}`,
                        deckItemId: s.id,
                        leftX: leftPost.x,
                        leftY: leftPost.y,
                        leftZ: section.edgeOffset,
                        leftPositionType: section.left.positionType,
                        rightX: rightPost.x,
                        rightY: rightPost.y,
                        rightZ: section.edgeOffset,
                        rightPositionType: section.right.positionType,
                        rightAngle: section.right.angle,
                        sectionSlope: section.slope,
                        order: j
                    });
                });
            });
            return fixingSystems;
        },
        $handrails: (s)=>{
            const handrails = s.$balustrades.flatMap((balustrade)=>{
                const recipes = [];
                const handrail = createRecipe({
                    type: 'Handrail',
                    key: `${balustrade.key}_handrail`,
                    deckItemId: s.id,
                    x: balustrade.handrail.handrailStart,
                    y: balustrade.handrail.handrailHeight,
                    z: balustrade.edgeOffset,
                    rotationX: 0,
                    rotationY: 0,
                    rotationZ: 0,
                    length: balustrade.handrail.handrailLength,
                    leftPositionType: balustrade.left.positionType,
                    rightPositionType: balustrade.right.positionType,
                    numberOfSections: balustrade.handrail.numberOfSections,
                    balustradeLength: balustrade.handrail.balustradeLength
                });
                recipes.push(handrail);
                const leftEnd = createRecipe({
                    type: 'HandrailEnd',
                    key: `${balustrade.key}_handrail_end_left`,
                    deckItemId: s.id,
                    x: balustrade.handrail.leftEndX,
                    y: balustrade.handrail.leftEndHeight,
                    z: balustrade.edgeOffset,
                    positionType: balustrade.left.positionType,
                    possibleWallEndType: HandrailPossibleWallEndType.Free,
                    endType: HandrailEndType.FlatEndCap,
                    angle: balustrade.left.angle,
                    slope: balustrade.left.slope
                });
                const rightEnd = createRecipe({
                    type: 'HandrailEnd',
                    key: `${balustrade.key}_handrail_end_right`,
                    deckItemId: s.id,
                    x: balustrade.handrail.rightEndX,
                    y: balustrade.handrail.rightEndHeight,
                    z: balustrade.edgeOffset,
                    positionType: balustrade.right.positionType,
                    possibleWallEndType: HandrailPossibleWallEndType.Free,
                    endType: HandrailEndType.FlatEndCap,
                    angle: balustrade.right.angle,
                    slope: balustrade.right.slope
                });
                recipes.push(leftEnd);
                if (!balustrade.handrail.sharedRightEnd) {
                    recipes.push(rightEnd);
                }
                return recipes;
            });
            return handrails;
        }
    }
});

//# sourceMappingURL=deck-section.js.map